/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface CareerInfoClassInfoPayload {
    careerId: string;
}

export interface CareerClassInfoListItem {
    application: string;
    capacity: string;
    classId: string;
    className: string;
    classRoomNm: string;
    classroom: string;
    cost: string;
    cost1: string;
    placeFileName: string;
    placeUrl: string;
    startToEndDate: string;
    startDate: string;
    endDate: string;
    classroomDefault: string;
    applicationStartline: string;
    applicationDeadline: string;
    placeUrlDefault: string;
    placeFileNameDefault: string;
    careerId: string;
}

export interface ContentsItem {
    contents: string;
}

export interface MaterialFilesItem {
    fileName: string;
    fileIndex: number;
    fileType: string;
}

export interface CareerInfoData {
    author: string;
    careerId: string;
    careerReport: string;
    careerSubType: string;
    careerTitle: string;
    careerTypeId: string;
    careerTypeName: string;
    comment: string;
    compulsoryId: string;
    contents: ContentsItem[];
    credit: number;
    enquete: string;
    haveContents: number;
    informationUrl: string;
    inquiry: string;
    managementCode: string;
    materialFiles: MaterialFilesItem[];
    months: string;
    organizer: string;
    outline: string;
    purpose: string;
    reference: string;
    referenceUrl: string;
    studyTime: string;
    target: string;
    textbook: string;
    vendor: string;
    vendorUrl: string;
    version: string;
    webAppFlg: string;
    careerGeneralMst1: string;
    careerGeneralMst2: string;
    careerGeneralMst3: string;
    careerGeneralMst4: string;
    careerGeneralMst5: string;
    careerGeneralMst6: string;
    careerGeneralMst7: string;
    careerGeneralMst8: string;
    careerGeneralMst9: string;
    careerGeneralMst10: string;
    careerGeneralNum1: number;
    careerGeneralNum2: number;
    careerGeneralNum3: number;
    careerGeneralNum4: number;
    careerGeneralNum5: number;
    careerGeneralText1: string;
    careerGeneralText2: string;
    careerGeneralText3: string;
    careerGeneralText4: string;
    jyukoNoClass: string;
    careerImageUrl?: string;
}

export interface CareerInfoClassInfoResponse {
    careerClassInfoList: CareerClassInfoListItem[];
    careerInfoData: CareerInfoData;
}

class CareerInfoClassInfoService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "careerInfoClassInfo");
    }

    public async careerInfoClassInfo(
        payload: CareerInfoClassInfoPayload,
        resolved: (json: CareerInfoClassInfoResponse) => void,
        rejected: (error: any) => void
    ) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as CareerInfoClassInfoResponse;
                resolved(response);
            },
            rejected
        );
    }
}

export default CareerInfoClassInfoService;
